import { useState, useCallback } from "react";
import * as analyticsApi from "../api/analyticsApi";

/**
 * useFlow — data-fetching hook for Feature Flow queries.
 * Mirrors the same pattern as useInsights.
 */
export const useFlow = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = useCallback(async (queryDSL, teamId = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await analyticsApi.executeFlow(queryDSL, teamId);
      // The backend wraps results as { success: true, data: { nodes, links, anchors, totalUsers } }
      const engineResult = response?.data?.data ?? response?.data ?? null;
      setResult(engineResult);
      return engineResult;
    } catch (err) {
      const errorMessage = analyticsApi.getErrorMessage(err);
      if (!analyticsApi.isAbortedOrCancelled(err)) {
        setError(errorMessage);
        setResult(null);
      }
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearResult = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { result, loading, error, execute, clearResult };
};
